import React, {FC, Fragment, useEffect} from 'react';
import {connect} from "react-redux";
import EmptyFavorite from "../../components/Favorite/EmptyFavorite";
import NavBar from "../../components/NavBar";
import {setActivePage} from "../../modules/System";
import FavoriteList from "../../components/Favorite/FavoriteList";
import Header from "../../components/Header";
import {removeFavoriteMix, setCurrentMix, updateAllFavoriteMix} from "../../modules/Favorite";
import WrapperPreloader from "../../components/WrapperPreloader";

interface IFavoriteContainer {
    favorite: Array<string>,
    activePage: string,
    setActivePage: any,
    removeFavoriteMix: any,
    initializationData: any,
    setCurrentMix: any,
    updateAllFavoriteMix: any,
    isLoading: boolean,
    favoriteMixes: any
}

const FavoriteContainer: FC<IFavoriteContainer> = ({
                                                       favorite,
                                                       activePage,
                                                       setActivePage,
                                                       removeFavoriteMix,
                                                       setCurrentMix,
                                                       updateAllFavoriteMix,
                                                       isLoading,
                                                       favoriteMixes
                                                   }) => {

    useEffect(() => {
        updateAllFavoriteMix();
        // eslint-disable-next-line
    }, []);


    return (
        <WrapperPreloader isLoading={isLoading}>
            <Fragment>
                <Header isContentCenter>
                    <span className="header__standard-text">
                        Любимое
                    </span>
                </Header>
                {
                    !favorite.length
                        ? <EmptyFavorite/>
                        : <FavoriteList
                            favoriteMixes={favoriteMixes}
                            favorite={favorite}
                            setCurrentMix={setCurrentMix}
                            removeFavoriteMix={removeFavoriteMix}
                        />
                }
                <NavBar
                    activePage={activePage}
                    setActivePage={setActivePage}
                />
            </Fragment>
        </WrapperPreloader>
    )
};

const mapStateToProps = (state: any) => ({
    favorite: state.favorite.favoriteMixes,
    isLoading: state.favorite.isLoading,
    activePage: state.system.activePage,
    favoriteMixes: state.favorite.favoriteMixes,
});

const mapDispatchToProps = (dispatch: any) => ({
    setActivePage: (page: string) => dispatch((setActivePage(page))),
    removeFavoriteMix: (id: number) => dispatch((removeFavoriteMix(id))),
    setCurrentMix: (id: number) => dispatch((setCurrentMix(id))),
    updateAllFavoriteMix: () => dispatch(updateAllFavoriteMix()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FavoriteContainer);

